import { Injectable, OnDestroy } from '@angular/core'
import { SecurityMappingKey } from '@helios/panels/security-mapping'
import {
  focusPanelAction,
  RootState,
  securityMappingAction,
  SecurityMappingFilter,
  setFocusedSecurityMappingFilter,
} from '@helios/state-management'
import { Actions, ofType } from '@ngrx/effects'
import { Store } from '@ngrx/store'
import { Subject } from 'rxjs'
import { takeUntil } from 'rxjs/operators'

/**
 * Listen to redux for focused files and trigger the External File panel Redux action to focus the appropriate panel on the appropriate item.
 * Depending on the details of the particular break, this determines what item needs to be focused on and sets that item as focused in Redux.
 */
@Injectable()
export class SecurityMappingEffects implements OnDestroy {
  private readonly _destroyed$ = new Subject<void>()

  constructor(
    private readonly store: Store<RootState>,
    private readonly actions$: Actions,
  ) {
    this.actions$
      .pipe(takeUntil(this._destroyed$), ofType(securityMappingAction))
      .subscribe(action => this.onSecurityMappingFocused(action['payload']))
  }

  ngOnDestroy(): void {
    this._destroyed$.next()
    this._destroyed$.complete()
  }

  private onSecurityMappingFocused(rawData: SecurityMappingFilter | undefined) {
    if (!rawData) return
    this.store.dispatch(setFocusedSecurityMappingFilter(rawData))
    setTimeout(() => this.focusPanel(SecurityMappingKey))
  }

  private focusPanel(panelKey: string) {
    this.store.dispatch(focusPanelAction(panelKey))
  }
}
